import { render, staticRenderFns } from "./vivamod-business.vue?vue&type=template&id=e9f2d908&"
import script from "./vivamod-business.vue?vue&type=script&lang=js&"
export * from "./vivamod-business.vue?vue&type=script&lang=js&"
import style0 from "./vivamod-business.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports